// extracted by mini-css-extract-plugin
module.exports = {"suggestions":"SearchSuggestions_suggestions__DXMZI","suggestion":"SearchSuggestions_suggestion__1CwFu"};